import { ReactHOC } from '@shared/react';
import { SelectFiledProps } from './interfaces';
import { Field, useField, useForm, useFormState } from 'react-final-form';
import { useCallback, useEffect, useState } from 'react';

export const withSelectField: ReactHOC<Partial<SelectFiledProps>> = (Component) => {
    return (props) => {
        const { name, validate, inputSize = 'large', ...rest } = props;

        const form = useForm();

        const { values } = useFormState();

        const {
            meta: { error, touched },
            input,
        } = useField(name!);

        const onSelect = useCallback(
            (value: string | null) => {
                form.change(name!, value);
            },
            [form, name],
        );

        const [currentValue, setCurrentValue] = useState<string | null>(null);

        useEffect(() => {
            setCurrentValue(values?.[name!] || null);
        }, [values, name]);

        return (
            <Field
                name={name!}
                validate={validate}
                render={() => {
                    return (
                        //@ts-ignore
                        <Component
                            {...rest}
                            inputSize={inputSize}
                            feedback={touched ? error || null : null}
                            {...input}
                            onSelect={onSelect}
                            currentValue={currentValue}
                        />
                    );
                }}
            />
        );
    };
};
